import { Contact, CreateContactResponse, CreateLead, Lead } from "@mmh/types"
import { defineMutation, useMutation } from "@pinia/colada"
import { getApiBaseUrl } from "~/lib/api"
import { digest } from "~/lib/crypto"

export const useCreateLead = defineMutation(() => {
    const mutation = useMutation<Lead, CreateLead>({
        mutation: async (params) => {
            const url = `${getApiBaseUrl()}/leads`
            const body = JSON.stringify(params)
            const req = new Request(url, { method: "post", body })

            req.headers.set("x-amz-content-sha256", await digest(body))
            req.headers.set("content-type", "application/json")

            const res = await fetch(req)
            const json = await res.json()

            if (!res.ok) {
                throw json
            }

            return json
        }
    })
        

    return {
        createLead: mutation.mutateAsync,
        createdLead: mutation.data,
        createLeadError: mutation.error,
        createLeadLoading: mutation.isLoading
    }
})

export const useCreateHubspotContact = defineMutation(() => {
    const mutation = useMutation<CreateContactResponse, Contact>({
        mutation: async (params) => {
            const url = `${getApiBaseUrl()}/hubspot/contact`
            const body = JSON.stringify(params)
            const req = new Request(url, { method: "post", body })

            req.headers.set("x-amz-content-sha256", await digest(body))
            req.headers.set("content-type", "application/json")

            const res = await fetch(req)
            const json = await res.json()

            if (!res.ok) {
                throw json
            }

            return json
        }
    })

    return {
        createContact: mutation.mutateAsync,
        createContactError: mutation.error,
        createContactLoading: mutation.isLoading
    }
})